import React from 'react'
import { FormGroup, TextArea, Card, H5 } from '@blueprintjs/core'

const Context = ({ context, onInputChange, protocol }) => {

    const handleChangeInput = e => {
        const name = e.target.name;
        let value = e.target.value;

        onInputChange(name, value);
    }

    return (
        <Card>
            <br />
            <H5 className='text-center'>{(protocol === 'PC') ?
                "This will be the main question of your session, it will be displayed during all sequences"
                :
                "This text will be displayed during the session, it will help participants to understand in wich context they have to evaluate"}</H5><br />
            <FormGroup
                // label="Context de la session"
                // labelInfo={helpContextTag}
                className="create-session-label-context context-fill"
            >
                <TextArea
                    style={{ height: "100px" }}
                    fill={true}
                    placeholder={(protocol === 'PC') ? 'Write your question here ...' : 'Write context of session here ...'}
                    onChange={handleChangeInput}
                    name="context"
                    defaultValue={context ? context : ""}
                />
            </FormGroup>
        </Card>
    )
}

export default Context
